<script>
import MultiSelect from "vue-multiselect";
import { required, decimal } from "vuelidate/lib/validators";
import VueDropify from "vue-dropify";

// Custom Components
import UserService from "@/helpers/APIService/user.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";

import {
  periodOptions,
  perOptions,
  whenCanPurchaseOptions,
  upSellPriceType,
} from "@/helpers/global.variable";

// up sell Component

export default {
  page: {
    title: "StaffForm",
  },
  components: {
    MultiSelect,
    VueDropify,
  },
  data() {
    return {
      periodOptions,
      perOptions,
      whenPurchaseAvailable: whenCanPurchaseOptions,
      selectedUpsellTime: [],
      upSellPriceType,
      upSell: {
        title: "",
        short_name: "",
        description: "",
        price: "",
        price_type: "",
        base_on: "",
        period: "",
        image: null,
        is_mandatory: false,
        is_approval_required: false,
        booking_source: [],
        is_active: true,
        is_deleted: false,
      },
      // dateRange: [],
      editId: null,
      bookingSourcesOptions: [],
      imageUrl: null,
      submitted: false,
      isBtnLoading: false,
      isImageUploading: false,
      isSaveAndAddNew: false,
      createError: false,
      errorMessage: "",
    };
  },
  computed: {
    ...authComputed,
  },
  props: {
    currentProps: Object,
  },
  validations: {
    upSell: {
      title: {
        required,
      },
      short_name: {
        required,
      },
      price: {
        required,
        decimal,
      },
      base_on: {
        required,
      },
      price_type: {
        required,
      },
      period: {
        required,
      },
    },
    selectedUpsellTime: {
      required,
    },
  },
  emits: ["submitted", "saveAndAddNew", "cancelSubmit"],
  mounted() {
    this.getBookingSourceList();
    this.setValue();
  },
  methods: {
    // Method is used to get booking source list
    async getBookingSourceList() {
      const response = await UserService.getBookingSourceByName();
      this.bookingSourcesOptions = response;
    },
    // Method is used to set value
    setValue() {
      if (this.currentProps.isEdit) {
        UserService.getUpSellDetails(this.currentProps.updateValueId)
          .then((response) => {
            this.editId = response.id;
            this.upSell.title = response.title;
            this.upSell.short_name = response.short_name;
            this.upSell.is_deleted = response.is_deleted;
            this.upSell.description = response.short_description;
            this.upSell.price = response.price;
            this.upSell.price_type = response.price_type;
            this.upSell.base_on = response.base_on;
            this.upSell.period = response.period;
            this.upSell.image =
              response.image !== null || undefined ? response.image : null;

            this.upSell.is_mandatory = response.is_mandatory;
            this.upSell.is_approval_required = response.is_approval_required;
            this.upSell.booking_source = response.booking_source;
            Object.keys(response.when_can_purchase).map((key) => {
              if (response.when_can_purchase[key] == true) {
                this.selectedUpsellTime.push({
                  text: key.replaceAll("_", " ").toUpperCase(),
                  value: key,
                });
              }
            });
            this.upSell.is_active = response.is_active;
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
    },
    // Method is used to handle add and update upsell
    handleSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        let data = {
          hotel: this.hotel.id,
          title: this.upSell.title,
          short_name: this.upSell.short_name,
          short_description:
            this.upSell.description != null &&
            this.upSell.description != undefined
              ? this.upSell.description
              : this.upSell.title,
          price: this.upSell.price,
          price_type: this.upSell.price_type,
          base_on: this.upSell.base_on,
          is_mandatory: this.upSell.is_mandatory,
          is_approval_required: this.upSell.is_approval_required,
          booking_source: [],
          is_active: true,
        };
        let obj = {};
        this.whenPurchaseAvailable.map((key) => {
          if (
            this.selectedUpsellTime.find((item) => item.value == key.value) !==
            undefined
          ) {
            obj[key.value] = true;
          } else {
            obj[key.value] = false;
          }
        });
        if (this.upSell.period !== "") {
          data = {
            ...data,
            period: this.upSell.period,
            when_can_purchase: obj,
          };
        }
        const bookingSourceArr = [];
        this.upSell.booking_source.map((item) => {
          bookingSourceArr.push(item.id);
        });
        data.booking_source = bookingSourceArr;
        this.isBtnLoading = false;
        if (!this.currentProps.isEdit) {
          UserService.createUpSell(data)
            .then((response) => {
              this.submitImages(response.id);
              if (this.isSaveAndAddNew) {
                this.$emit("saveAndAddNew", response);
              } else {
                this.$emit("submitted", response);
              }
              this.isBtnLoading = false;
              this.submitted = false;
            })
            .catch((error) => {
              this.isBtnLoading = false;
              this.createError = true;
              errorHandler(error);
              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
              } else {
                this.errorMessage = error.response.data;
              }
            });
        } else {
          UserService.updateUpSell(this.currentProps.updateValueId, data)
            .then((response) => {
              this.$emit("submitted", response, this.currentProps.isEdit);
              this.isBtnLoading = false;
              this.submitted = false;
              Middleware.notification("Successfully updated !!", "success");
            })
            .catch((error) => {
              this.isBtnLoading = false;
              this.createError = true;
              errorHandler(error);

              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
              } else {
                this.errorMessage = error.response.data;
              }
            });
        }
      }
    },
    // Method is used to add and continue add new record
    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.handleSubmit();
    },
    // Method is used to cancle submition
    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },
    // Method is used to handle change image
    changeImage(event) {
      this.imageUrl = event[0] == undefined ? null : event[0];
      if (this.imageUrl !== null && this.currentProps.isEdit) {
        this.submitImages(this.editId, "isShow");
      }
    },
    // Method is used to handle submition of image
    submitImages(id, status) {
      this.isImageUploading = true;
      const imageData = new FormData();
      imageData.append("image", this.imageUrl);
      UserService.updateUpSell(id, imageData)
        .then((response) => {
          this.$root.$emit("addImageInUpSell", response);
          this.upSell.image = response.image;
          if (status == "isShow") {
            Middleware.notification("Image updated successfully !!", "success");
          }
          this.isImageUploading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
  },
};
</script>

<template>
  <div>
    <b-form ref="staff-form">
      <div class="row">
        <div class="col-md-12">
          <b-card-title>
            <h4>
              {{ this.currentProps.isEdit ? "Update" : "Add" }} Up Sell Details
            </h4>
            <h4 v-if="createError">
              <template v-if="typeof errorMessage == 'object'">
                <span v-for="error in errorMessage" :key="error">
                  <span class="badge card-badge badge-soft-danger">
                    <b>{{ error }}</b>
                  </span>
                  <br />
                </span>
              </template>
              <template v-else>
                <span class="badge card-badge badge-soft-danger">
                  <b>{{ errorMessage }}</b>
                </span>
              </template>
            </h4>
          </b-card-title>
          <hr />
        </div>
        <div class="col-md-6">
          <b-form-group class="mb-3" label-for="title-input">
            <span slot="label">Title <span class="text-danger">*</span></span>
            <b-form-input
              id="title-input"
              type="text"
              placeholder="Title"
              v-model="upSell.title"
              :disabled="this.currentProps.isEdit ? !upSell.is_deleted : false"
              autocomplete="off"
              :class="{
                'is-invalid': submitted && $v.upSell.title.$error,
              }"
            ></b-form-input>
            <div
              v-if="submitted && $v.upSell.title.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.upSell.title.required">Title is required.</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group class="mb-3" label-for="short-name-input">
            <span slot="label"
              >Short Name <span class="text-danger">*</span></span
            >
            <b-form-input
              id="short-name-input"
              type="text"
              placeholder="Short Name"
              v-model="upSell.short_name"
              :disabled="this.currentProps.isEdit ? !upSell.is_deleted : false"
              autocomplete="off"
              :class="{
                'is-invalid': submitted && $v.upSell.short_name.$error,
              }"
            ></b-form-input>
            <div
              v-if="submitted && $v.upSell.short_name.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.upSell.short_name.required"
                >Short Name is required.</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group class="mb-3" label-for="price-input">
            <span slot="label">Price <span class="text-danger">*</span></span>
            <b-form-input
              id="price-input"
              type="text"
              placeholder="Price"
              v-model="upSell.price"
              autocomplete="off"
              :class="{
                'is-invalid': submitted && $v.upSell.price.$error,
              }"
            ></b-form-input>
            <div
              v-if="submitted && $v.upSell.price.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.upSell.price.required">Price is required.</span>
              <span v-if="!$v.upSell.price.decimal"
                >Price should be in decimal.</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group class="mb-3" label-for="price-input">
            <span slot="label"
              >Price Type <span class="text-danger">*</span></span
            >
            <b-form-select
              class="form-select"
              id="price_type"
              type="text"
              autocomplete="off"
              placeholder="Price Type"
              v-model="upSell.price_type"
              :options="upSellPriceType"
              :class="{
                'is-invalid': submitted && $v.upSell.price_type.$error,
              }"
            >
            </b-form-select>
            <div
              v-if="submitted && $v.upSell.price_type.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.upSell.price_type.required"
                >Price Type is required.</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group class="mb-3" label-for="base_on-input">
            <span slot="label"
              >Based On <span class="text-danger">*</span></span
            >
            <b-form-select
              class="form-select"
              id="base_on-input"
              type="text"
              autocomplete="off"
              placeholder="based on"
              v-model="upSell.base_on"
              :options="perOptions"
              :class="{
                'is-invalid': submitted && $v.upSell.base_on.$error,
              }"
            >
            </b-form-select>
            <div
              v-if="submitted && $v.upSell.base_on.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.upSell.base_on.required"
                >Based On is required.</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group
            class="mb-3"
            label="Is This UpSell Mandatory?"
            label-for="mandatory"
          >
            <b-form-select
              class="form-select"
              id="mandatory"
              type="text"
              autocomplete="off"
              placeholder="Yes/No"
              v-model="upSell.is_mandatory"
              :options="[
                { text: 'Yes', value: true },
                { text: 'No', value: false },
              ]"
            >
            </b-form-select>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group class="mb-3" label="Period" label-for="period-input">
            <span slot="label">Period <span class="text-danger">*</span></span>
            <b-form-select
              class="form-select"
              id="period"
              type="text"
              autocomplete="off"
              placeholder="Period"
              v-model="upSell.period"
              :options="periodOptions"
              :class="{
                'is-invalid': submitted && $v.upSell.period.$error,
              }"
            >
            </b-form-select>
            <div
              v-if="submitted && $v.upSell.period.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.upSell.period.required">Period is required.</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            class="mb-3"
            label="Is Required Aprooval?"
            label-for="approval-input"
          >
            <b-form-select
              class="form-select"
              id="approval"
              type="text"
              placeholder="Yes/No"
              v-model="upSell.is_approval_required"
              :options="[
                { text: 'Yes', value: true },
                { text: 'No', value: false },
              ]"
            >
            </b-form-select>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            class="mb-3"
            label="Short Description"
            label-for="Description-input"
          >
            <b-form-input
              id="description-input"
              type="text"
              placeholder="Short Description"
              v-model="upSell.description"
              autocomplete="off"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="title_text">Select Booking Source </label>
            <b-button-group class="float-end">
              <b-button
                size="sm"
                variant="outline-primary"
                @click="upSell.booking_source = bookingSourcesOptions"
                >Attach All</b-button
              >
              <b-button
                size="sm"
                variant="outline-primary"
                @click="upSell.booking_source = []"
                >Detach All</b-button
              >
            </b-button-group>
            <MultiSelect
              v-model="upSell.booking_source"
              track-by="name"
              label="name"
              placeholder="Select Booking Sources"
              :options="bookingSourcesOptions"
              :multiple="true"
              :taggable="true"
              :show-labels="false"
            >
              <template slot="singleLabel" slot-scope="{ option }"
                ><strong> {{ option.name }}</strong></template
              >
            </MultiSelect>
          </div>
        </div>

        <div class="col-md-6">
          <b-form-group
            class="mb-3"
            label="When Can Guest Purchase This?"
            label-for="period-input"
          >
            <span slot="label"
              >When Can Guest Purchase This?
              <span class="text-danger">*</span></span
            >
            <MultiSelect
              v-model="selectedUpsellTime"
              track-by="value"
              label="text"
              placeholder="Select Upsell Display option"
              :options="whenPurchaseAvailable"
              :multiple="true"
              :class="{
                'is-invalid': submitted && $v.selectedUpsellTime.$error,
              }"
            >
            </MultiSelect>
            <div
              v-if="submitted && $v.selectedUpsellTime.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.selectedUpsellTime.required"
                >When Can Purchase is required.</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <label for="image">Image <span class="text-danger">*</span></label>
          <div v-if="!isImageUploading">
            <VueDropify
              @upload="changeImage($event)"
              :src="upSell.image"
              message="Drop image or click here to select"
              class="mb-3"
            />
          </div>
          <div class="col-md-3 placeholder-glow" v-if="isImageUploading">
            <p class="placeholder placeholder-lg common-upload-img-size"></p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-2">
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="reset"
            @click="cancelSubmit"
            >Cancel</b-button
          >
          <b-button
            v-if="this.currentProps.isEdit === false"
            class="float-end ms-2"
            variant="outline-primary"
            type="button"
            :class="{ disabled: isSaveAndAddNew === true && isBtnLoading }"
            @click="saveAndAddNew"
          >
            <i
              v-if="isSaveAndAddNew === true && isBtnLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i>
            Save & Add</b-button
          >
          <b-button
            class="float-end"
            variant="outline-primary"
            @click="handleSubmit"
            :class="{ disabled: isSaveAndAddNew !== true && isBtnLoading }"
          >
            <i
              v-if="isSaveAndAddNew !== true && isBtnLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i>
            {{ currentProps.isEdit ? "Update" : "Save" }}
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>
